import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initFirebase, getFcmToken } from './firebase';
import { getMessaging, onMessage } from 'firebase/messaging';
import { initConectividade } from './signals/conectividade';
import ConfigUtil from './util/config';

const initializeApp = (config) => {
    global.gConfig = config;
    console.log('config', config);

    initConectividade();

    const rootElement = document.getElementById('root');
    
    // Previne criação de múltiplas roots no mesmo elemento
    if (!rootElement._reactRootContainer) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(<App />);
    }
};

// Previne execução múltipla do código de inicialização
// Verifica se já existe root criada ou se já está em processo de inicialização
const rootElement = document.getElementById('root');
if (!rootElement._reactRootContainer && !window.__APP_INITIALIZING__) {
    window.__APP_INITIALIZING__ = true;
    Promise.all([
        fetch(`${process.env.PUBLIC_URL}/config/changelog.json`).then((response) => response.json()),
        fetch(`${process.env.PUBLIC_URL}/config/config.json`).then((response) => response.json()),
    ])
        .then(async ([changelog, bootstrap]) => {
            const config = await ConfigUtil.resolverConfigInstancia(bootstrap);
            return [changelog, config];
        })
        .then(([changelog, config]) => {
            initializeApp(ConfigUtil.mesclarConfig(config, changelog));
            window.__APP_INITIALIZING__ = false;
        })
        .catch((error) => {
            console.error('Erro ao buscar os arquivos de configurações do frontend', error);
            window.__APP_INITIALIZING__ = false;
        });
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then(async () => {
                const firebaseConfig = global.gConfig && global.gConfig.firebase;
                if (!firebaseConfig) return;
                await initFirebase(firebaseConfig);
                const token = await getFcmToken(firebaseConfig.vapidKey);
                if (token) {
                    // TODO: enviar token para o backend para receber pushes deste device
                    console.info('FCM token registrado', token);
                }

                const messaging = getMessaging();

                onMessage(messaging, (payload) => {
                    console.log('Mensagem recebida em foreground: ', payload);

                    // Opcional: Mostrar notificação nativa do navegador
                    const { title, body, icon } = payload.notification;

                    // Verifica se temos permissão
                    if (Notification.permission === 'granted') {
                        new Notification(title, {
                            body: body,
                            icon: icon || '/icon-192.png',
                        });
                    }
                });
            })
            .catch((err) => {
                console.error('Falha ao registrar service worker', err);
            });
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
